var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "mainAppBody", attrs: { id: "app" } },
    [
      _vm.isOffline
        ? _c("div", {
            staticClass: "smile-no-connection",
            style: {
              backgroundImage: "url(" + _vm.noInternetConnectionImg + ")"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("GlobalAlert"),
      _vm._v(" "),
      _c("Header", { attrs: { isAuthenticated: _vm.isAuthenticated } }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            mode: "out-in",
            "enter-active-class": _vm.enterActiveClass,
            "leave-active-class": _vm.leaveActiveClass
          }
        },
        [
          _c("router-view", {
            key: _vm.$route.fullpath,
            on: { "show-global-alert": _vm.showAlert }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer", { attrs: { isAuthenticated: _vm.isAuthenticated } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","b-avatar":"src","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"src","b-card-img-lazy":["src","blank-src"],"b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 